module.exports = __webpack_public_path__ + "static/media/logo_fondo.831c0457.png";